/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_8_ProblemInputs */

const et_portfolio_project_8_problem = /** @type {(inputs: Portfolio_Project_8_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raskesti navigeeritav leht kehva kohaliku SEO nähtavusega.`)
};

const en_portfolio_project_8_problem = /** @type {(inputs: Portfolio_Project_8_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hard-to-navigate site with poor local SEO visibility.`)
};

/**
* | output |
* | --- |
* | "Hard-to-navigate site with poor local SEO visibility." |
*
* @param {Portfolio_Project_8_ProblemInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_8_problem = /** @type {((inputs?: Portfolio_Project_8_ProblemInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_8_ProblemInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_8_problem(inputs)
	return en_portfolio_project_8_problem(inputs)
});